import { render, staticRenderFns } from "./ConfigTabDutyTypes.vue?vue&type=template&id=51d5c946"
import script from "./ConfigTabDutyTypes.vue?vue&type=script&lang=js"
export * from "./ConfigTabDutyTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports